import {AuthService} from '../auth.service';
import { AppConstants } from "../app.constants";
import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { NavItem } from '../nav-item';
import { NavService } from '../nav.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { SharedProvider } from '../appservices/shared';
import { Router } from '@angular/router';
import { EXPLORER_NAV } from '../explorer-hunt/explorer-hunt.module';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LandingpageComponent implements OnInit {
  @ViewChild('drawer',{static: false}) appDrawer: ElementRef;
  isHandset: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.Handset);
  appVersion = AppConstants.CONSTANTS.currentVersion;
  navItems: NavItem[] = [
    {
      displayName: 'Bookings',
      iconName: 'ticket',
      route: '/landingpage/bookings',
    },
    {
      displayName: 'Spaces',
      iconName: 'building',
      children: [
        {
          displayName: 'Space List',
          route: '/landingpage/manage'
        },
        {
          displayName: 'Space Search',
          route: '/landingpage/searchspace'
        },
        {
          displayName: 'Add Space',
          route: 'landingpage/add-space'
        },
      ]
    },
    // {
    //   displayName: 'Food Redemptions',
    //   iconName: 'Food redemtions.png',
    //   route: '/landingpage/foodredemption',
    // },
    {
      displayName: 'Reports',
      iconName: 'table',
      children: [
        {
          displayName: 'Payment Report',
          route: '/landingpage/reportdashboard'
        },
        // {
        //   displayName: 'Food Redemption Report',
        //   route: '/landingpage/fooddashboard'
        // },
        // {
        //   displayName: 'Food Credits Purchase Report',
        //   route: '/landingpage/foodcreditspurchasereport'
        // },
        {
          displayName: 'Booking List',
          route: '/landingpage/dashboard'
        },
        {
          displayName: 'Org Bookings',
          route: '/landingpage/orgbookings'
        },
        {
          displayName: 'Enquiries',
          route: '/landingpage/enquiries'
        },
        {
          displayName: 'User List',
          route: '/landingpage/userdashboard'
        },
        {
          displayName: 'Voucher List',
          route: '/landingpage/voucherdashboard'
        },
        // {
        //   displayName: 'Floater Pass Report',
        //   route: '/landingpage/floaterpassreport'
        // },
        {
          displayName: 'Referral Report',
          route: '/landingpage/referralreport'
        }
      ]
    },
    {
      displayName: 'Tools',
      iconName: 'gear',
      children: [
        {
          displayName: 'Send Notifications',
          route: '/landingpage/notifications'
        },
        {
          displayName: 'Create Payment Link',
          route: '/landingpage/paymentlink'
        },
        {
          displayName: 'Generate Bookings',
          route: '/landingpage/generate-bookings'
        },
        {
          displayName: 'Space Bulk Update',
          route: '/landingpage/spacebulkupdate'
        },
        {
          displayName: 'Bulk Update New',
          route: '/landingpage/space-bulk-update-new'
        },
        {
          displayName: 'Partner Invoices',
          route: '/landingpage/partnerinvoices'
        },
        // {
        //   displayName: 'Space Collections',
        //   route: '/landingpage/promotion-details'
        // },
        // {
        //   displayName: 'Community Partners',
        //   route: '/landingpage/communitypartners'
        // },
        {
          displayName: 'Organizations',
          route: '/landingpage/organizations'
        },
        {
          displayName: 'Space Suggestions',
          route: '/landingpage/searchcollections'
        },
        {
          displayName: 'Payment Transactions',
          route: '/landingpage/paymenttransactions'
        },
        {
          displayName: 'Manage User',
          route: '/landingpage/manage-user'
        },
         {
          displayName: 'FAQ',
          route: '/landingpage/faq'
        },
        {
          displayName: 'Space Rocket',
          route: '/landingpage/space-rocket'
        },
      ]
    },
    EXPLORER_NAV,
    {
      displayName: 'Help',
      iconName: 'info',
      route: '/landingpage/help',
    },
    // Config — added dynamically for authorised users only; kept last so it appends after Help
  ];
  header: string;
  sidebarCollapsed: boolean = false;

  toggleSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  constructor( public logoutservice:AuthService, public navService: NavService,
    private breakpointObserver: BreakpointObserver, private router: Router,
    private sharedService : SharedProvider) { 
   
  }

  private readonly BULK_UPDATE_EMAILS = ['shyam@gofloaters.com', 'radhakrishnan@gofloaters.com'];
  private readonly SHYAM_EMAIL = 'shyam@gofloaters.com';

  private applyNavPermissions(email: string) {
    const toolsMenu = this.navItems.find(item => item.displayName === 'Tools');
    if (!toolsMenu || !toolsMenu.children) return;

    if (!this.BULK_UPDATE_EMAILS.includes(email)) {
      toolsMenu.children = toolsMenu.children.filter(c => c.displayName !== 'Bulk Update New');
    }

    // Config menu — visible to Shyam and Radhakrishnan only; inserted right after Tools
    if (this.BULK_UPDATE_EMAILS.includes(email)) {
      if (!this.navItems.find(item => item.displayName === 'Config')) {
        const toolsIndex = this.navItems.findIndex(item => item.displayName === 'Tools');
        const insertAt = toolsIndex >= 0 ? toolsIndex + 1 : this.navItems.length;
        this.navItems.splice(insertAt, 0, {
          displayName: 'Config',
          iconName: 'sliders',
          children: [
            { displayName: 'Cities', route: '/landingpage/config/cities' },
            { displayName: 'Booking Assignments', route: '/landingpage/config/booking-assignments' },
            { displayName: 'Website Cities', route: '/landingpage/config/website-cities' },
            { displayName: 'Website Localities', route: '/landingpage/config/website-localities' },
            { displayName: 'WorqFlexi Domains', route: '/landingpage/config/worqflexi-domains' },
            { displayName: 'Switch Payment Mode', route: '/landingpage/switch-payment-mode' },
          ]
        });
      }
    }
  }

  ngOnInit() {
    this.logoutservice.afAuth.authState.subscribe(auth => {
      if (auth && auth.email) {
        this.applyNavPermissions(auth.email);
      }
    });

    let that =this;
    this.sharedService.bookingTitle.subscribe((text : string) => {
      if(window.location.pathname.indexOf('viewbooking') > 0)
      {
        that.header = text;
      }      
    });
    this.sharedService.spaceTitle.subscribe((text : string) => {
      if(window.location.pathname.indexOf('viewspace') > 0)
      {
        that.header = text;
      }
    });
    this.navService.currentUrl.subscribe((url: string) => {
      this.navItems.forEach(item => {
        if(item.children) {
          item.children.forEach(child => {
            if(child.route !== undefined && url.indexOf(`${child.route}`) === 0) {
              that.header = child.displayName;
            }
          })
        }
        if(item.route !== undefined && url.indexOf(`${item.route}`) === 0) {
          that.header = item.displayName;
        }
      })
        
        
    });
  }
  logout(){
    this.logoutservice.signOut()
  }
}
